import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import alertEmailConfirmation from 'flarum/utils/alertEmailConfirmation';

import UserApplyInviteCodeModal from "./UserApplyInviteCodeModal";
import getUserInfo from "../../common/util/getUserInfo";

export default class AccountNeedActivateModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = false;

  oninit(vnode) {
    super.oninit(vnode);
    this.sent = false;
    this.loading = false;
  }

  className() {
    return 'Modal--medium';
  }

  title() {
    return app.translator.trans('ziven-u2di.lib.confirmation');
  }

  content() {
    const userID = app.session.user.id();
    const userInfoData = getUserInfo(userID);
    const email = userInfoData.email();
    const from = "indexPage";

    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div style="font-size: 14px;padding-bottom: 20px;height: 60px;">
            {app.translator.trans('ziven-u2di.forum.error-account-not-activated',{email:email})}
          </div>
          <div>
            {Button.component({
                className: 'Button U2DiButton--yellow',
                disabled: this.loading || this.sent,
                onclick: () => {
                  this.loading = true;
                  m.redraw();
            
                  app
                    .request({
                      method: 'POST',
                      url: app.forum.attribute('apiUrl') + '/users/' + userID + '/send-confirmation',
                    })
                    .then(() => {
                      this.loading = false;
                      this.sent = true;
                      m.redraw();
                    })
                    .catch(() => {
                      this.loading = false;
                      m.redraw();
                    });
                }
              },
              app.translator.trans(this.sent===false?'ziven-u2di.forum.button-resend-email':'ziven-u2di.forum.button-sent-email')
            )}&nbsp;
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading,
                onclick: () => {
                  app.session.logout();
                }
              },
              app.translator.trans('ziven-u2di.forum.title-user-logout')
            )}
          </div>
        </div>
      </div>
    );
  }
}
